import React, { useState } from 'react'
import { adresZdjeciaOsoby } from '../../api/account'

/**
 * Zdjęcie osoby z zespołu (kafelek, karta osoby) albo pierwsza litera na tle koloru. Zdjęcie idzie z
 * `GET /zespol/osoby/{id}/zdjecie?v=<wersja>`: nowa wersja zmienia adres, więc przeglądarka nie trzyma starego.
 * Gdy obrazek się nie wczyta, zostaje litera.
 */
const Awatar = ({ osoba, rozmiar = 48 }) => {
  const [blad, setBlad] = useState(false)
  const styl = { width: rozmiar, height: rozmiar, fontSize: Math.round(rozmiar * 0.42) }
  const nazwa = osoba.imie || osoba.email || '?'
  if (osoba.zdjecie_wersja && !blad) {
    return (
      <img src={adresZdjeciaOsoby(osoba.id, osoba.zdjecie_wersja)} alt="" style={styl} onError={() => setBlad(true)}
           className="flex-shrink-0 rounded-full border border-gray-100 object-cover" />
    )
  }
  return (
    <span style={styl} aria-hidden="true"
          className={`flex flex-shrink-0 items-center justify-center rounded-full font-bold ${
            osoba.rola === 'owner' ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-700'}`}>
      {nazwa.charAt(0).toUpperCase()}
    </span>
  )
}

export default Awatar
